import { ReactNode, useState } from "react";
import classNames from "classnames";

interface SelectorOption {
  content: ReactNode;
  value: string;
  disabled?: boolean;
}

interface MultiSelectorProps {
  className?: string;
  options: SelectorOption[];
  value?: string;
  defaultOption?: string;
  onChange: (newValue: SelectorOption) => void;
}

export const MultiSelector = ({
  className,
  options,
  value,
  defaultOption,
  onChange,
}: MultiSelectorProps) => {
  const defaultIndex = options.findIndex(
    (option) => defaultOption === option.value
  );
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(
    defaultIndex < 0 ? 0 : defaultIndex
  );

  const valueIndex = value
    ? options.findIndex((option) => option.value === value)
    : null;

  if (!options?.length) return;

  return (
    <div
      className={classNames(
        "w-full flex items-center h-fit max-h-fit",
        className
      )}
    >
      {options.map((option, index) => (
        <div
          key={`option-${index}`}
          onClick={(event) => {
            event.stopPropagation();
            if (option.disabled) return;

            setSelectedIndex(index);
            onChange?.(option);
          }}
          style={{
            width: `${100 / options?.length}%`,
          }}
          className={classNames(
            "flex items-center justify-center h-auto self-stretch px-[4px] py-1 cursor-pointer first:rounded-l-2xl last:rounded-r-2xl border-[2px] active:scale-[98.5%] transition-transform ease-out",
            {
              "border-gray-200 bg-gray-100 py-2 !cursor-not-allowed":
                option.disabled,
              "border-primary-500 bg-primary-500/10":
                (valueIndex || selectedIndex) === index && !option.disabled,
              "bg-gradient1":
                (valueIndex || selectedIndex) !== index && !option.disabled,
            }
          )}
        >
          {option.content}
        </div>
      ))}
    </div>
  );
};
